!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t=t||self).uuidv4=e()}(this,(function(){"use strict";var t="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||"undefined"!=typeof msCrypto&&"function"==typeof msCrypto.getRandomValues&&msCrypto.getRandomValues.bind(msCrypto),e=new Uint8Array(16);function n(){if(!t)throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");return t(e)}for(var o=[],r=0;r<256;++r)o.push((r+256).toString(16).substr(1));return function(t,e,r){"string"==typeof t&&(e="binary"===t?new Uint8Array(16):null,t=null);var u=(t=t||{}).random||(t.rng||n)();if(u[6]=15&u[6]|64,u[8]=63&u[8]|128,e){for(var i=r||0,d=0;d<16;++d)e[i+d]=u[d];return e}return function(t,e){var n=e||0,r=o;return(r[t[n+0]]+r[t[n+1]]+r[t[n+2]]+r[t[n+3]]+"-"+r[t[n+4]]+r[t[n+5]]+"-"+r[t[n+6]]+r[t[n+7]]+"-"+r[t[n+8]]+r[t[n+9]]+"-"+r[t[n+10]]+r[t[n+11]]+r[t[n+12]]+r[t[n+13]]+r[t[n+14]]+r[t[n+15]]).toLowerCase()}(u)}}));
// Shopify 埋点全上报
var contextWindow = window.contextWindow || window;
var contextDocument = window.contextDocument || document;
var contextLocation = window.contextWindow.location;
window.Rd = {
    ipinfo: {}, // 国家地址信息
    systemInfo: {}, // 设备信息
    timestamp: Date.parse(new Date()), // 当前时间戳
    uid: uuidv4(),
    utms: ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gad_source', 'gclid', 'dclid', 'fbclid'],
    init: function() {
        var S = this;
        S.systemInfo = S.getDevice();
        if (S.getCookie('s_s_scene')) {
            S.setCookie('s_utm_source', S.getCookie('s_s_scene'), 15*24*60);
            S.delCookie('s_s_scene');
        }
        if (S.getCookie('s_s_referrer') == null) {
            S.setCookie('s_s_referrer', document.referrer, 15*24*60);
        }
        if (document.referrer && !document.referrer.includes('goelia1995.com')) {
            // 替换来源
            S.setCookie('s_s_referrer', document.referrer, 15*24*60);
        }
        S.setQueryCookie();
        if (S.getCookie('ipinfoNew')) {
            S.ipinfo = JSON.parse(S.getCookie('ipinfoNew'));
            S.initStart();
        } else {
            S.getSystemInfo(function () {
                S.initStart();
            })
        }

        // 10s 发送一次心跳事件
        setInterval( function () {
            S.heartBeat();
        }, 10000);

        // 25s 发送一次end事件
        setInterval( function () {
            S.sendEnd();
        }, 25000);

        S.bindEvents();
    },
    setQueryCookie: function () {
        var S = this
        var hasValue = false;
        S.utms.forEach(function (item) {
            if (S.getQueryString(item)) {
                S.setCookie('s_' + item, S.getQueryString(item), 15*24*60)
                hasValue = true;
            }
        })
        if (hasValue) {
            S.utms.forEach(function (item) {
                if (!S.getQueryString(item)) {
                    S.delCookie('s_' + item);
                }
            })
        }
    },
    heartBeat: function () {
        // 心跳
        var S = this;
        var params = {
            action: 'heartBeat',
            pend: Date.parse(new Date())
        }
        S.initParams(params);
    },
    initStart: function () {
        var S = this;
        var params = {
            action: 'start',
            pstar: Date.parse(new Date())
        }
        S.initParams(params);
        // S.pay();
    },
    sendEnd: function () {
        var S = this;
        var params = {
            action: 'end',
            pend: Date.parse(new Date())
        }
        S.initParams(params);
    },
    initParams: function (params) {
        var S = this;
        // 参数组装
        var initPage = S.getCookie('coll_init_page');
        var uid = S.getCookie('coll_uid');
        if (!uid) {
            uid = uuidv4();
            // 会话id 设置30分钟
            S.setCookie('coll_uid', uid, 30);
        }
        var sessionTimer = S.getCookie('coll_timer');
        if (!sessionTimer) {
            sessionTimer = S.timestamp;
            S.setCookie('coll_timer', sessionTimer);
        }
        var sessionStart = false;
        if (!S.getCookie('init')) {
            sessionStart = true;
            S.setCookie('init', 'init')
        }
        var __initPage = '',
            initQuery = '';
        if (initPage) {
            __initPage = initPage;
            initQuery = initPage.split('?')[1] || '';
        } else {
            __initPage = contextLocation.href;
            initQuery = contextLocation.search;
            S.setCookie('coll_init_page', contextLocation.href);
        }
        var query = contextLocation.search;
        if (window.meta && $('body').hasClass('template-product') && window.meta.product) {
            // 详情页特殊处理
            if (query.indexOf('?') > -1) {
                query += '&goodsId=' + window.meta.product.id;
            } else {
                query += '?goodsId=' + window.meta.product.id;
            }
        }
        var __data = {
            appId: '2200',
            action: params.action,
            storeId: '2200',
            storeName: '歌莉娅Shopify澳洲站',
            pageInfo: {
                initPage: __initPage, // 用户首次进入shopify的页面，存在cookie里面
                initPageQuery: initQuery, //
                pageUrl: contextLocation.href,
                pageQuery: contextLocation.search,
                lastPageUrl: contextDocument.referrer,
                lastPageQuery: (contextDocument.referrer && contextDocument.referrer.split('?')[1]) || '',
                sessionStart: sessionTimer,
                sessionId: uid,
                isSessionStart: sessionStart, // 用户首次进入shopify的页面为true，其他都是false
                isSessionEnd: params.isSessionEnd, // 发送end，用户关掉浏览器为true，其他为false
                pvID: S.uid,
                pstar: params.pstar || 0,
                pend: params.pend || 0,
                scene: params.scene || S.getCookie('s_s_scene'),
                referrerUrl: S.getCookie('s_s_referrer') || ''
            },
            userInfo: {
                userId: $('#userId').val() || S.ipinfo.ip,
                location: {
                    country: S.ipinfo.country,
                }
            },
            systemInfo: {
                adt: S.systemInfo.dev, // 设备标识
                scr: contextWindow.innerWidth, // 屏幕尺寸（width）
                jv: S.systemInfo.os // 操作系统
            },
            data: params.data || {}
        }
        S.utms.forEach(function (item) {
            S.getCookie('s_' + item) && (__data.pageInfo[item] = S.getCookie('s_' + item));
        })
        __data.pageInfo = JSON.stringify(__data.pageInfo);
        __data.userInfo = JSON.stringify(__data.userInfo);
        __data.systemInfo = JSON.stringify(__data.systemInfo);
        __data.data = JSON.stringify(__data.data);
        if (contextLocation.host.indexOf('goelia1995dev.myshopify.com') > -1) return;
        $.ajax({
            type: 'get',  //提交方式
            url: "https://spfda.goelia1995.com/swingsDataDtc/collect/collectData",//路径
            data: __data, //数据，这里使用的是Json格式进行传输
            success : function(res) {},
            error: function () {}
        });
    },
    jsonp: function(url, callback) {
        // 生成一个随机的回调函数名
        const callbackName = 'jsonp_' + Math.round(100000 * Math.random());

        // 将回调函数名作为参数添加到请求URL中
        const script = document.createElement('script');
        script.setAttribute('referrerPolicy', 'no-referrer');
        script.src = `${url}?callback=${callbackName}`;
        document.body.appendChild(script);

        // 将回调函数添加到全局对象中
        window[callbackName] = function (data) {
            // 数据获取成功后，删除script标签和回调函数
            delete window[callbackName];
            document.body.removeChild(script);
            // 调用回调函数，传入获取到的数据
            callback(data);
        };
    },
    getSystemInfo: function (callback) {
        var S = this;
        S.jsonp("https://ipinfo.io", function(response) { // we changed to https
            if (response) {
                S.ipinfo = response;
                S.setCookie('ipinfoNew', JSON.stringify(response), 24 * 60);
                callback && callback(response);
            }
        }, "jsonp");
    },
    pay: function () {
        var currentURL = contextLocation.href;
        // 首次进入感谢页
        if (currentURL.indexOf("/checkouts/")!==-1 && currentURL.indexOf("/thank-you")!==-1) {
            // 发送埋点
            this.initParams({
                action: 'pay',
                data: {
                    orderNum: $('#orderId').val(),
                    payment: $('#totalPrice').val(),
                    payTime: Date.parse($('#createdAt').val())
                }
            });
        }
    },
    getDevice: function () {
        /* 版本信息获取 */
        // 各主流浏览器
        var getBrowser = function () {
            var u = navigator.userAgent
            var bws = [{
                name: 'sgssapp',
                it: /sogousearch/i.test(u)
            }, {
                name: 'wechat',
                it: /MicroMessenger/i.test(u)
            }, {
                name: 'weibo',
                it: !!u.match(/Weibo/i)
            }, {
                name: 'uc',
                it: !!u.match(/UCBrowser/i) || u.indexOf(' UBrowser') > -1
            }, {
                name: 'sogou',
                it: u.indexOf('MetaSr') > -1 || u.indexOf('Sogou') > -1
            }, {
                name: 'xiaomi',
                it: u.indexOf('MiuiBrowser') > -1
            }, {
                name: 'baidu',
                it: u.indexOf('Baidu') > -1 || u.indexOf('BIDUBrowser') > -1
            }, {
                name: '360',
                it: u.indexOf('360EE') > -1 || u.indexOf('360SE') > -1
            }, {
                name: '2345',
                it: u.indexOf('2345Explorer') > -1
            }, {
                name: 'edge',
                it: u.indexOf('Edge') > -1
            }, {
                name: 'ie11',
                it: u.indexOf('Trident') > -1 && u.indexOf('rv:11.0') > -1
            }, {
                name: 'ie',
                it: u.indexOf('compatible') > -1 && u.indexOf('MSIE') > -1
            }, {
                name: 'firefox',
                it: u.indexOf('Firefox') > -1
            }, {
                name: 'safari',
                it: u.indexOf('Safari') > -1 && u.indexOf('Chrome') === -1
            }, {
                name: 'qqbrowser',
                it: u.indexOf('MQQBrowser') > -1 && u.indexOf(' QQ') === -1
            }, {
                name: 'qq',
                it: u.indexOf('QQ') > -1
            }, {
                name: 'chrome',
                it: u.indexOf('Chrome') > -1 || u.indexOf('CriOS') > -1
            }, {
                name: 'opera',
                it: u.indexOf('Opera') > -1 || u.indexOf('OPR') > -1
            }]
            for (var i = 0; i < bws.length; i++) {
                if (bws[i].it) {
                    return bws[i].name
                }
            }

            return 'other'
        };
        // 系统区分
        var getOS = function () {
            var u = navigator.userAgent
            if (!!u.match(/compatible/i) || u.match(/Windows/i)) {
                return 'windows'
            } else if (!!u.match(/Macintosh/i) || u.match(/MacIntel/i)) {
                return 'macOS'
            } else if (!!u.match(/iphone/i) || u.match(/Ipad/i)) {
                return 'ios'
            } else if (u.match(/android/i)) {
                return 'android'
            } else if (u.match(/Ubuntu/i)) {
                return 'Ubuntu'
            } else {
                return 'other'
            }
        };
        //判断数组中是否包含某字符串
        Array.prototype.contains = function (needle) {
            for (i in this) {
                if (this[i] && this[i].indexOf(needle) > 0)
                    return i;
            }
            return -1;
        }

        var device_type = navigator.userAgent; //获取userAgent信息
        // document.write(device_type); //打印到页面
        var md = new MobileDetect(device_type); //初始化mobile-detect
        var os = md.os(); //获取系统
        console.log(os)
        var model = "";
        if (os == "iOS") { //ios系统的处理
            os = +md.version("iPhone");
            console.log(os)
            model = md.mobile();
        } else if (os == "AndroidOS") { //Android系统的处理
            os = md.os() + md.version("Android");
            var sss = device_type.split(";");
            var i = sss.contains("Build/");
            if (i > -1) {
                model = sss[i].substring(0, sss[i].indexOf("Build/"));
            }
        }
        else {
            os = getOS();
            model = getBrowser();
        }
        //alert(os + "---" + model);//打印系统版本和手机型号
        //console.log(model + '||' + os, '打印系统版本和手机型号')
        return { "os": os, "dev": model }
    },
    checkUrl: function(url){
        //url= 协议://(ftp的登录信息)[IP|域名](:端口号)(/或?请求参数)
        var strRegex = '^((https|http|ftp)://)?'//(https或http或ftp):// 可有可无
            + '(([\\w_!~*\'()\\.&=+$%-]+: )?[\\w_!~*\'()\\.&=+$%-]+@)?' //ftp的user@  可有可无
            + '(([0-9]{1,3}\\.){3}[0-9]{1,3}' // IP形式的URL- 3位数字.3位数字.3位数字.3位数字
            + '|' // 允许IP和DOMAIN（域名）
            + '(localhost)|'    //匹配localhost
            + '([\\w_!~*\'()-]+\\.)*' // 域名- 至少一个[英文或数字_!~*\'()-]加上.
            + '\\w+\\.' // 一级域名 -英文或数字  加上.
            + '[a-zA-Z]{1,6})' // 顶级域名- 1-6位英文
            + '(:[0-9]{1,5})?' // 端口- :80 ,1-5位数字
            + '((/?)|' // url无参数结尾 - 斜杆或这没有
            + '(/[\\w_!~*\'()\\.;?:@&=+$,%#-]+)+/?)$';//请求参数结尾- 英文或数字和[]内的各种字符

        var strRegex1 = '^(?=^.{3,255}$)((http|https|ftp)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/)?(?:\/(.+)\/?$)?(\/\w+\.\w+)*([\?&]\w+=\w*|[\u4e00-\u9fa5]+)*$';
        var re = new RegExp(strRegex,'i');//i不区分大小写
        //将url做uri转码后再匹配，解除请求参数中的中文和空字符影响
        if (re.test(encodeURI(url))) {
            return (true);
        } else {
            return (false);
        }
    },
    bindEvents: function () {
        var S = this;
        // 点击a 标签跳转发送一次end事件
        $(document).on('click', 'a', function () {
            var o = $(this);
            var href = o.attr('href') || 'javascript:;';
            if (S.checkUrl(href) || href.indexOf('/') === 0) {
                S.sendEnd();
            }
        })
    },
    delCookie: function (key) {
        var val = this.getCookie(key);
        if (val != null) {
          this.setCookie(key, val, -1);
        }
    },
    setCookie: function(name, value, timer) {
        var Days = timer || 30 * 24 * 60;
        var exp = new Date();
        exp.setTime(exp.getTime() + Days * 60 * 1000);
        var cookieValue = value !== undefined && value !== null && value !== '' ? encodeURI(value) : "";
        document.cookie =
          name + "=" + cookieValue + ";expires=" + exp.toGMTString() + ';path=/';
    },
    getCookie: function(name) {
        var arr,
          reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if ((arr = document.cookie.match(reg))) return decodeURIComponent(arr[2]);
        else return null;
    },
    getQueryString: function(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        var r = contextLocation.search.substring(1).match(reg);
        if (r != null) {
            return decodeURIComponent(r[2]);
        }
        return null;
    }
}
window.Rd.init();
